var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15C15.5653 15 19 11.9399 19 8C19 4.06015 15.5653 1 11.5 1C7.43474 1 4 4.06015 4 8C4 11.9399 7.43474 15 11.5 15Z",
    fill: "#9CD0ED",
    stroke: "#9CD0ED",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33C14.8561 33 17.4878 32.5388 19.4425 31.7569C20.417 31.3671 21.2728 30.8779 21.9013 30.2835C22.5319 29.6872 23 28.9159 23 28C23 27.0841 22.5319 26.3128 21.9013 25.7165C21.2728 25.1221 20.417 24.6329 19.4425 24.2431C17.4878 23.4612 14.8561 23 12 23C9.14392 23 6.51218 23.4612 4.55754 24.2431C3.58299 24.6329 2.72723 25.1221 2.09874 25.7165C1.46814 26.3128 1 27.0841 1 28C1 28.9159 1.46814 29.6872 2.09874 30.2835C2.72723 30.8779 3.58299 31.3671 4.55754 31.7569C6.51218 32.5388 9.14392 33 12 33Z",
    fill: "#9CD0ED",
    stroke: "#9CD0ED",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1441 11.1775C42.1441 9.9755 41.1824 9 39.9974 9C38.8124 9 37.8507 9.9755 37.8507 11.1775L37.8504 14.8191L34.1467 14.8214C32.9617 14.8214 32 15.7969 32 16.9988C32 18.2008 32.9617 19.1763 34.1467 19.1763L37.8504 19.174L37.8507 22.8225C37.8507 24.0245 38.8124 25 39.9974 25C41.1824 25 42.1441 24.0245 42.1441 22.8225L42.1438 19.174L45.8533 19.1763C47.0383 19.1763 48 18.2008 48 16.9988C48 15.7969 47.0383 14.8214 45.8533 14.8214L42.1438 14.8191L42.1441 11.1775Z",
    fill: "#9CD0ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/CreateAccount.e4b7db99ce1c5189eee1a8478756af86.svg";
export { ForwardRef as ReactComponent };